'use client';

import { tooltipClasses } from './SiteHeader.style';

interface SiteHeaderTooltipProps {
  id: string;
  /** The item's accessible name, shown as text (never markup). */
  text: string;
}

/**
 * An inline, non-portaled tooltip, tied to its trigger with `aria-describedby`.
 *
 * ## Invariants:
 * - Never portaled: the header picks desktop vs phone with `useMediaQuery`, and a portaled tooltip
 *   would escape that branch. The parent renders it only while its trigger is hovered or focused.
 */
export function SiteHeaderTooltip({ id, text }: SiteHeaderTooltipProps) {
  return (
    <span id={id} role="tooltip" className={tooltipClasses} data-cy="site-header-tooltip">
      {text}
    </span>
  );
}
